export default "/images/d40aa408157c37c155e225def539520a.avif";